import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


class TermsService extends Component {

  static propTypes = {

  };

  constructor(props) {
    super(props);

    this.state = {

    };

    if (this.props.isLoggedIn) {
      this.props.history.push('./dashboard');
    }
  }

  render() {
    return (
      <div>Terms & Service</div>
    );
  }

}

const mapStateToProps = (state) => ({
  isLoggedIn: state.isLoggedIn
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(TermsService);
